import { IconButtonProps } from '@mui/material'
import { IconButton } from 'utoniq-ui'

type Props = {
  playing: boolean
  onClickPlay: IconButtonProps['onClick']
  onClickPause: IconButtonProps['onClick']
  bgcolor?: string
  color?: string
}

export const VoicePlayerControl = ({
  playing,
  onClickPlay,
  onClickPause,
  bgcolor = 'grey.50',
  color,
}: Props) => {
  return playing ? (
    <IconButton.AudioOn
      bgcolor={bgcolor}
      color={color}
      size="small"
      onClick={onClickPause}
    />
  ) : (
    <IconButton.AudioOff
      bgcolor={bgcolor}
      color={color}
      size="small"
      onClick={onClickPlay}
    />
  )
}
